module.exports = __webpack_public_path__ + "img/screen-manual-15.23c6fe35.png";